.priority-selector-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  width: 2.4rem;
  height: 2.4rem;
  margin-inline-end: 0.8rem;
  background-color: #25272d;
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline-end: 0.8rem;
}
